module.exports = __webpack_public_path__ + "img/tarjeta_servicios_talleres_calidad.3c8e2acc.jpg";